<template>
	<b-overlay :show="showOverlay" rounded="sm">
		<b-card class="sa-card sa-page-dashboard-card-body-chart" style="height: 100%" :header="chartParams.title" header-tag="header" footer-tag="footer" title="">
			<template #header>
				<div style="display: flex">
					<span style="flex: 1">{{ chartParams.title }}</span>

					<b-button size="sm" variant="outline-secondary outline-secondary-noborder pull-right" @click="onClickEditConfigChart()">
						<i class="fas fa-pencil-alt"></i>
					</b-button>
					<b-button size="sm" variant="outline-danger outline-secondary-noborder pull-right" @click="onClickRimuoviOggetto()">
						<i class="fas fa-trash"></i>
					</b-button>
					<b-button size="sm" variant="outline-secondary outline-secondary-noborder pull-right" @click="onClickZoomChart(chartParams)">
						<i class="fas fa-search-plus"></i>
					</b-button>
					<b-button size="sm" variant="outline-secondary outline-secondary-noborder pull-right" @click="onClickViewData(chartParams)">
						<i class="fas fa-database"></i>
					</b-button>
					<b-button size="sm" variant="outline-secondary outline-secondary-noborder pull-right" @click="onClickEditDetails()"> <i class="far fa-edit"></i></b-button>
				</div>
			</template>
			<b-card-body>
				<div v-if="chartParams.type === 'graphic'" class="sa-page-dashboard-body-graphic" style="height: 300px">
					<generic-chart-component :marginLeft="marginLeft" :legendVisible="legendVisible" :horizontalBar="horizontalDirection" xAxisType="value" :chartData="chartData" :chartType="chartParams.graphicType"></generic-chart-component>
				</div>
				<div v-else>
					<p>{{ chartParams }}</p>
					<b-card-text class="text-right sa-dashboard-data-text">{{ chartParams.value }}</b-card-text>
				</div>
			</b-card-body>
			<data-analysis-modal-view-data-component ref="mdlDataAnalysisModalViewDataComponent"></data-analysis-modal-view-data-component>
			<data-analysis-chart-view-modal-component ref="mdlDataAnalysisChartViewModalComponent"></data-analysis-chart-view-modal-component>
			<data-analysis-edit-config-chart-modal-component ref="mdlDataAnalysisEditConfigChartComponent" @updateConfig="onUpdateConfig"></data-analysis-edit-config-chart-modal-component>
			<data-analysis-dashboard-pivot-edit-modal-component
				ref="mdlDataAnalysisDashboardPivotEditModalComponent"
				@beforeLoadData="onBeforeLoadDataMdlDataAnalysisDashboardPivotEditModalComponent"
				@afterLoadData="onAfterLoadDataMdlDataAnalysisDashboardPivotEditModalComponent"
				@updatePivotParams="onUpdatePivotParams"
			></data-analysis-dashboard-pivot-edit-modal-component>
		</b-card>
		<sa-modal-loading ref="cmpSaModalLoading"></sa-modal-loading>
	</b-overlay>
</template>

<script>
import { SaModalLoading } from "../../../template/components/modal";
import GenericChartComponent from "../../utility/components/GenericChartComponent.vue";
import DataAnalysisModalViewDataComponent from "./DataAnalysisModalViewDataComponent.vue";
import DataAnalysisChartViewModalComponent from "./DataAnalysisChartViewModalComponent.vue";
import DataAnalysisEditConfigChartModalComponent from "./DataAnalysisEditConfigChartModalComponent.vue";
import DataAnalysisDashboardPivotEditModalComponent from "./DataAnalysisDashboardPivotEditModalComponent.vue";
import DataAnalysisChartMixin from "../mixins/DataAnalysisChartMixin";
export default {
	props: {
		chartParams: { type: Object },
	},
	mixins: [DataAnalysisChartMixin],
	components: { SaModalLoading, GenericChartComponent, DataAnalysisModalViewDataComponent, DataAnalysisChartViewModalComponent, DataAnalysisEditConfigChartModalComponent, DataAnalysisDashboardPivotEditModalComponent },
	computed: {
		marginLeft() {
			return this.chartParams.marginLeft;
		},
		legendVisible() {
			return this.chartParams.legendVisible;
		},
		horizontalDirection() {
			return this.chartParams.horizontalDirection;
		},
	},
	mounted() {
		this.$emit("beforeLoadData", this.chartParams);
		if (this.chartParams.idQuery) {
			this.setChartData();
		} else {
			this.showOverlay = false;
		}
	},
	data() {
		return {
			chartData: { titolo: "", unitaMisura: "", xAxis: [{ type: "value" }], series: [] },
			pathResourceData: "/dataanalysisdatabaseinfo/eseguigraphicquery",
			showOverlay: true,
			queryResult: [],
			configChart: { fileds: [], dimension: "", xvalue: "", filters: "" },
		};
	},
	methods: {
		// onClickViewData() {
		// 	let me = this;
		// 	me.$refs.mdlDataAnalysisModalViewDataComponent.setData(me.queryResult);
		// 	me.$refs.mdlDataAnalysisModalViewDataComponent.show();
		// },
		// onClickZoomChart() {
		// 	let me = this;
		// 	let chartParams = { title: me.chartParams.title, headerElements: [], bodyElement: me.chartParams, chartData: me.chartData };
		// 	me.$refs.mdlDataAnalysisChartViewModalComponent.setChartParams(chartParams);
		// 	me.$refs.mdlDataAnalysisChartViewModalComponent.show();
		// },
		// onUpdatePivotParams(pivotParams) {
		// 	this.chartParams.pivotParams = pivotParams;
		// 	this.$emit("updateChart");
		// },
		onUpdateConfig() {
			//console.log("Aggiornamento della configurazione");
			//this.chartParams = updateConfig;
			this.loadDataQuery();
			this.$emit("updateChart");
		},
		onClickEditDetails() {
			this.$refs.mdlDataAnalysisDashboardPivotEditModalComponent.show(this.chartParams);
		},
		onClickEditConfigChart() {
			let me = this;
			// console.log(me.chartParams);
			me.$refs.mdlDataAnalysisEditConfigChartComponent.setChartParams(me.chartParams, me.configChart.fileds);
			me.$refs.mdlDataAnalysisEditConfigChartComponent.show();
		},
		onClickRimuoviOggetto() {
			this.$emit("removeObject", this.chartParams);
		},
		onBeforeLoadDataMdlDataAnalysisDashboardPivotEditModalComponent() {
			this.$refs.cmpSaModalLoading.show();
		},
		onAfterLoadDataMdlDataAnalysisDashboardPivotEditModalComponent() {
			this.$refs.cmpSaModalLoading.close();
		},
	},
};
</script>

<style></style>
